<div class="donor-login-dialog">
  <!-- Close Button -->
  <button class="close-button" (click)="onClose()" type="button" aria-label="Close dialog">
    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 0.5L0.5 5.5M0.5 0.5L5.5 5.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- Content -->
  <div class="dialog-content">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">{{ 'auth.donor_login.title' | translateLang }}</h2>
      <p class="dialog-subtitle">{{ 'auth.donor_login.subtitle' | translateLang }}</p>
    </div>

    <!-- Form Container -->
    <div class="form-container">
      <!-- Error Message - Displayed above the form -->
      @if (errorMessage() || errorHtml()) {
        <div class="error-banner">
          @if (errorHtml()) {
            <span [innerHTML]="errorHtml()"></span>
          } @else {
            <span>{{ errorMessage() }}</span>
          }
        </div>
      }

      <!-- Login Form -->
    <form class="login-form" (ngSubmit)="onSubmitLogin()" #loginForm="ngForm">
      <!-- Username Field -->
      <div class="form-field">
        <label for="username" class="field-label">{{ 'auth.donor_login.username_label' | translateLang }}</label>
        <input
          type="text"
          id="username"
          name="username"
          class="field-input"
          [(ngModel)]="username"
          (input)="clearError()"
          required
          [disabled]="isLoading()"
          [placeholder]="'auth.donor_login.username_placeholder' | translateLang"
          autocomplete="username"
        />
      </div>

      <!-- Password Field -->
      <div class="form-field">
        <div class="password-label-row">
          <label for="password" class="field-label">{{ 'auth.donor_login.password_label' | translateLang }}</label>
          <a href="#" class="forgot-password-link" (click)="onForgotPassword($event)">{{ 'auth.donor_login.reset_password' | translateLang }}</a>
        </div>
        <div class="password-input-wrapper">
          <input
            [type]="showPassword() ? 'text' : 'password'"
            id="password"
            name="password"
            class="field-input"
            [(ngModel)]="password"
            (input)="clearError()"
            required
            [disabled]="isLoading()"
            [placeholder]="'auth.donor_login.password_placeholder' | translateLang"
            autocomplete="current-password"
          />
          <button
            type="button"
            class="toggle-password-button"
            (click)="togglePasswordVisibility()"
            [disabled]="isLoading()"
            aria-label="Toggle password visibility"
          >
            @if (showPassword()) {
              <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 5.16667C0.5 5.16667 2.5 0.5 7.16667 0.5C11.8333 0.5 13.8333 5.16667 13.8333 5.16667C13.8333 5.16667 11.8333 9.83333 7.16667 9.83333C2.5 9.83333 0.5 5.16667 0.5 5.16667Z" stroke="#71717A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.16667 7.16667C8.27124 7.16667 9.16667 6.27124 9.16667 5.16667C9.16667 4.0621 8.27124 3.16667 7.16667 3.16667C6.0621 3.16667 5.16667 4.0621 5.16667 5.16667C5.16667 6.27124 6.0621 7.16667 7.16667 7.16667Z" stroke="#71717A" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            } @else {
              <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 5.16667C0.5 5.16667 2.5 0.5 7.16667 0.5C11.8333 0.5 13.8333 5.16667 13.8333 5.16667C13.8333 5.16667 11.8333 9.83333 7.16667 9.83333C2.5 9.83333 0.5 5.16667 0.5 5.16667Z" stroke="#71717A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.16667 7.16667C8.27124 7.16667 9.16667 6.27124 9.16667 5.16667C9.16667 4.0621 8.27124 3.16667 7.16667 3.16667C6.0621 3.16667 5.16667 4.0621 5.16667 5.16667C5.16667 6.27124 6.0621 7.16667 7.16667 7.16667Z" stroke="#71717A" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
          </button>
        </div>
      </div>

      <!-- Submit Button -->
      <button type="submit" class="sign-in-button" [disabled]="!loginForm.valid || isLoading()">
        @if (isLoading()) {
          <span class="loading-spinner"></span>
          <span>{{ submitLoadingLabel | translateLang }}</span>
        } @else {
          <span>{{ submitLabel | translateLang }}</span>
        }
      </button>
    </form>

    <!-- Divider -->
    <div class="divider">
      <span>{{ 'auth.donor_login.divider' | translateLang }}</span>
    </div>

      <!-- Guest Button -->
      <button type="button" class="guest-button" (click)="onContinueAsGuest()" [disabled]="isLoading()">
        <span>{{ 'auth.donor_login.continue_as_guest' | translateLang }}</span>
      </button>
    </div>

    <!-- Contact Support -->
    <p class="contact-support-text">
      {{ 'auth.donor_login.contact_support_prefix' | translateLang }}
      <a [href]="contactUrl" target="_blank" rel="noopener noreferrer" class="contact-support-link">{{ 'auth.donor_login.contact_support_link' | translateLang }}</a>
      {{ 'auth.donor_login.contact_support_suffix' | translateLang }}
    </p>

    <!-- Footer -->
    <div class="footer-container">
      <p class="footer-text">{{ 'auth.donor_login.footer_text' | translateLang }}</p>
      <p class="footer-text">
        <a [href]="termsUrl" target="_blank" rel="noopener noreferrer" class="footer-link">{{ 'auth.donor_login.terms_of_service' | translateLang }}</a>
        {{ 'auth.donor_login.footer_and' | translateLang }}
        <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer" class="footer-link">{{ 'auth.donor_login.privacy_policy' | translateLang }}</a>.
      </p>
    </div>
  </div>
</div>
